import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=96867846&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"
import style0 from "./TabHeader.vue?vue&type=style&index=0&id=96867846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96867846",
  null
  
)

export default component.exports